export const FIND_CART_REQUEST = 'FIND_CART_REQUEST';
export const FIND_CART_SUCCESS = 'FIND_CART_SUCCESS';
export const FIND_CART_FAILURE = 'FIND_CART_FAILURE';

export const CLEAR_CART_REQUEST = 'CLEAR_CART_REQUEST';
export const CLEAR_CART_SUCCESS = 'CLEAR_CART_SUCCESS';
export const CLEAR_CART_FAILURE = 'CLEAR_CART_FAILURE';

export const GET_ALL_CART_ITEMS_REQUEST = 'GET_ALL_CART_ITEMS_REQUEST';
export const GET_ALL_CART_ITEMS_SUCCESS = 'GET_ALL_CART_ITEMS_SUCCESS';
export const GET_ALL_CART_ITEMS_FAILURE = 'GET_ALL_CART_ITEMS_FAILURE';

export const ADD_ITEMS_TO_CART_REQUEST = 'ADD_ITEMS_TO_CART_REQUEST';
export const ADD_ITEMS_TO_CART_SUCCESS = 'ADD_ITEMS_TO_CART_SUCCESS';
export const ADD_ITEMS_TO_CART_FAILURE = 'ADD_ITEMS_TO_CART_FAILURE';

export const UPDATE_CARTITEM_REQUEST = 'UPDATE_CARTITEM_REQUEST';
export const UPDATE_CARTITEM_SUCCESS = 'UPDATE_CARTITEM_SUCCESS';
export const UPDATE_CARTITEM_FAILURE = 'UPDATE_CARTITEM_FAILURE';

export const REMOVE_CARTITEM_REQUEST = 'REMOVE_CARTITEM_REQUEST';
export const REMOVE_CARTITEM_SUCCESS = 'REMOVE_CARTITEM_SUCCESS';
export const REMOVE_CARTITEM_FAILURE = 'REMOVE_CARTITEM_FAILURE';